export default "__VITE_ASSET__DEq97wK2__"